import { UAParser } from 'ua-parser-js';

export function isIOSInAppBrowser(userAgentHeader: string | undefined) {
  const userAgent = new UAParser(userAgentHeader).getResult();

  const osName = userAgent.os.name?.toLowerCase();
  const browserName = userAgent.browser.name?.toLowerCase();

  if (
    osName === 'ios' &&
    (browserName === 'gsa' ||
      browserName === 'instagram' ||
      browserName === 'facebook')
  ) {
    return true;
  }

  return false;
}
